import { render, staticRenderFns } from "./ModalLocalisation.vue?vue&type=template&id=0901ed34&"
import script from "./ModalLocalisation.vue?vue&type=script&lang=js&"
export * from "./ModalLocalisation.vue?vue&type=script&lang=js&"
import style0 from "./ModalLocalisation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports